import { styled } from "@linaria/react";
export const ImageOverlayEditorStyle = /*#__PURE__*/styled('div')({
  name: "ImageOverlayEditorStyle",
  class: "gdg-i2iowwq",
  propsAsIs: false
});

